import { z } from 'zod';

import { positionDtoSchema } from '../position-geocode/position.dto.schema';

export const externalDtoSchema = z.object({
  id: z.number(),
  email: z.string(),
  name: z.string(),
  sector: z.string(),
  projectId: z.string(),
  organisationId: z.number(),
  code: z.string(),
  active: z.boolean(),
  expirationDate: z.string().nullable(),
  eventPosition: positionDtoSchema.nullable(),
  title: z.string().nullable(),
  scope: z.string(),
  scopeUrl: z.string(),
  completion: z.string(),
  status: z.string(),
  isValidated: z.boolean(),
  projectName: z.string(),
  projectLocation: z.string().nullable(),
  projectImage: z.string().nullable(),
  projectStartDate: z.string().nullable(),
  projectEndDate: z.string().nullable(),
});

export const calculateCo2ExternalDtoSchema = z.object({
  score: z.number(),
});

export type ExternalDto = z.infer<typeof externalDtoSchema>;
